import { gql } from '@apollo/client';
import { WarrantyErrorInfo } from '../fragments';

export default gql`
  query warrantyErrors {
    warrantyErrors {
      ...WarrantyErrorInfo
    }
  }
  ${WarrantyErrorInfo}
`;
